var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"balance"},[_c('p',{staticClass:"balance-text",style:({ backgroundImage: 'url(' + _vm.balanceSource + ')' })}),_c('h3',{staticClass:"balance-value"},[_vm._v(_vm._s(_vm._f("currencyFormat")(_vm.balanceValue/100)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }